/**
 * @generated SignedSource<<1d61d252896575ea2884d483ecd96119>>
 * @relayHash 1cdf55f994a6939963be94479cc21daf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 872712d044652e051fd8469f058c446a98f4a24a673c90d4f0a276d049ce2128

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSetDefaultNavigationItemInput = {
  id: string;
  scopeId?: string | null | undefined;
};
export type setAsDefaultItemMutation$variables = {
  input: JiraSetDefaultNavigationItemInput;
};
export type setAsDefaultItemMutation$data = {
  readonly jira: {
    readonly setDefaultNavigationItem: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly newDefault: {
        readonly isDefault: boolean | null | undefined;
        readonly label: string | null | undefined;
      } | null | undefined;
      readonly previousDefault: {
        readonly isDefault: boolean | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type setAsDefaultItemMutation = {
  response: setAsDefaultItemMutation$data;
  variables: setAsDefaultItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "label"
},
v4 = {
  "kind": "ScalarField",
  "name": "isDefault"
},
v5 = {
  "kind": "ScalarField",
  "name": "message"
},
v6 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "setAsDefaultItemMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSetDefaultNavigationItemPayload",
            "kind": "LinkedField",
            "name": "setDefaultNavigationItem",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "name": "newDefault",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "previousDefault",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ]
              },
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "setAsDefaultItemMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSetDefaultNavigationItemPayload",
            "kind": "LinkedField",
            "name": "setDefaultNavigationItem",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "name": "newDefault",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v8/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "previousDefault",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v4/*: any*/),
                  (v8/*: any*/)
                ]
              },
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/)
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "872712d044652e051fd8469f058c446a98f4a24a673c90d4f0a276d049ce2128",
    "metadata": {},
    "name": "setAsDefaultItemMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "bcaaa14d2f29d8020f8238f6031efdc3";

export default node;
